var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import Immutable from 'immutable';
import React, { Component } from 'react';
import { Icon } from "../../UI";
import { connect } from 'react-redux';
import { t } from "../../I18N";
import ConnectionsGroup from "./ConnectionsGroup";
import { LibraryViewRelationships } from "./LibraryViewRelationships";

class ConnectionsGroupsComponent extends Component {
  render() {
    const { connectionsGroups, expanded } = this.props;

    let Results = /*#__PURE__*/
    _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
    _jsx("h4", {}, void 0, t('System', 'No Relationships')), /*#__PURE__*/
    _jsx("p", {}, void 0, t('System', 'No Relationships description'))
    );


    if (connectionsGroups.size) {
      if (this.props.sidePanelTrigger === 'library') {
        Results = /*#__PURE__*/_jsx(LibraryViewRelationships, { expanded: expanded });
      } else {
        Results = /*#__PURE__*/
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx("div", { className: "nested-selector" }, void 0, /*#__PURE__*/
        _jsx("ul", { className: "multiselect is-active" }, void 0,
        connectionsGroups.map((group) => /*#__PURE__*/
        _jsx(ConnectionsGroup, { group: group }, group.get('key'))
        )
        )
        )
        );

      }
    }

    return Results;
  }
}

ConnectionsGroupsComponent.defaultProps = {
  expanded: false
};







function mapStateToProps({ relationships, library }) {
  return {
    connectionsGroups: relationships.list.connectionsGroups,
    sidePanelTrigger: library.sidepanel.view
  };
}

export const ConnectionsGroups = connect(mapStateToProps)(ConnectionsGroupsComponent);